// The eight sale dates in chronological order, with the labels both admin pages show
export const SALE_DATE_FIELDS = [
  { name: 'consignmentOpenDate', label: 'Consignment opens' },
  { name: 'consignmentCloseDate', label: 'Consignment closes' },
  { name: 'dropoffStartDate', label: 'Drop-off starts' },
  { name: 'dropoffEndDate', label: 'Drop-off ends' },
  { name: 'saleStartDate', label: 'Sale starts' },
  { name: 'saleEndDate', label: 'Sale ends' },
  { name: 'pickupStartDate', label: 'Pickup starts' },
  { name: 'pickupEndDate', label: 'Pickup ends' }
];

// [earlier, later, strict]. Keep in step with ORDER_RULES in api/src/dateConfig.js, which the
// API enforces; this copy only lets the form point at the problem before saving.
export const SALE_DATE_ORDER = [
  ['consignmentOpenDate', 'consignmentCloseDate', true],
  ['consignmentCloseDate', 'dropoffStartDate', false],
  ['dropoffStartDate', 'dropoffEndDate', false],
  ['dropoffEndDate', 'saleStartDate', false],
  ['saleStartDate', 'saleEndDate', true],
  ['saleEndDate', 'pickupStartDate', false],
  ['pickupStartDate', 'pickupEndDate', false]
];

export const SALE_DATE_LABELS = SALE_DATE_FIELDS.reduce((labels, field) => ({ ...labels, [field.name]: field.label }), {});
